import { useCallback, useEffect, useMemo, useState } from "react";
import { useLocalStorage } from "usehooks-ts";
import { AuthContext } from "@/contexts/auth";
import { EMAIL_KEY, FIRM_CODE_KEY, FIRM_NAME_KEY } from "@/lib/constants";

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [, , removeFirmName] = useLocalStorage(FIRM_NAME_KEY, "");
  const [, , removeFirmCode] = useLocalStorage(FIRM_CODE_KEY, "");
  const [, , removeEmail] = useLocalStorage(EMAIL_KEY, "");

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO: what is useCallback for here if there are no dependencies?
  const logout = useCallback(() => {
    removeFirmName();
    removeFirmCode();
    removeEmail();
    setIsAuthenticated(false);
  }, []);

  const login = useCallback(() => {
    setIsAuthenticated(true);
  }, []);

  const checkAuth = useCallback(async () => {
    const apiUrl = import.meta.env.VITE_API_URL;
    const response = await fetch(`${apiUrl}/api/Client/keep-alive`, {
      credentials: "include",
    });
    if (response.ok) {
      setIsAuthenticated(true);
    }
  }, []);

  useEffect(() => {
    void checkAuth();
    //call the api to check if the user is authenticated
  }, [checkAuth]);

  const value = useMemo(
    () => ({ isAuthenticated, login, logout }),
    [isAuthenticated, login, logout],
  );

  return <AuthContext value={value}>{children}</AuthContext>;
}
